import { useState, useCallback } from "react";
import { IoLocation } from "react-icons/io5";
import { AddressInputField, DropDownInput, InputField } from "@/components";
import {
  statesOptionsArray,
  StatesOptions,
  getStateKey,
} from "../../utils/Data";
import { useFieldError } from "@/";
import { useApi } from "@/";
const DeliveryDetails = ({
  data,
  setData,
  errors = [],
  isDisabled = false,
  isEdit = false,
  isView = false,
}) => {
  const { callApi } = useApi();
  const handleChange = useCallback(
    (field, value) => {
      setData((prev) => ({
        ...prev,
        deliveryAddress: {
          ...(prev.deliveryAddress || {}),
          [field]: value,
        },
      }));
    },
    [setData]
  );

const handlePincodeChange = useCallback(
  async (pincode) => {
    handleChange("pincode", pincode);

    if (pincode.length === 6) {
      try {
        const response = await fetch(
          `https://api.postalpincode.in/pincode/${pincode}`
        );

        if (!response.ok) return;

        const data = await response.json();

        if (data?.[0]?.Status === "Success" && data[0]?.PostOffice?.length) {
          const postOffice = data[0].PostOffice[0];

          handleChange("city", postOffice.District);
          handleChange("state", getStateKey(postOffice.State));
        }
      } catch (error) {
        console.error("Pincode fetch error:", error);
      }
    }
  },
  [handleChange]
);

  const handleAddressChange = useCallback(
    (field, value) => {
      setData((prev) => ({
        ...prev,
        deliveryAddress: {
          ...(prev.deliveryAddress || {}),
          lines: prev.deliveryAddress?.lines?.length
            ? prev.deliveryAddress.lines.map((line) => ({
                ...line,
                [field]: value,
              }))
            : [
                {
                  line1: field === "line1" ? value : "",
                  line2: field === "line2" ? value : "",
                },
              ],
        },
      }));
    },
    [setData]
  );
  console.log("State:::", StatesOptions[data.deliveryAddress?.state]);

  const handlePhoneChange = useCallback(
    (field, value) => {
      setData((prev) => {
        const currentPhones = prev.deliveryPhones?.length
          ? prev.deliveryPhones
          : [
              { phoneNumber: "", phoneType: "Primary" },
              { phoneNumber: "", phoneType: "Secondary" },
            ];

        return {
          ...prev,
          deliveryPhones: currentPhones.map((phone) => {
            if (phone.phoneType === field) {
              return { ...phone, phoneNumber: value };
            }
            return phone;
          }),
        };
      });
    },
    [setData]
  );

  const getErrorMessage = useFieldError(errors);

  return (
    <div className="w-full flex flex-col gap-2 border-2 border-secondary/30 rounded-2xl p-4 overflow-y-auto">
      <div className="flex gap-1 items-center">
        <IoLocation className="text-headline4 text-secondary/80" />
        <h2 className="text-headline4 text-secondary/80 font-nunito font-semibold">
          Delivery Details
        </h2>
      </div>

      <form className="flex flex-col gap-2 w-full">
        <InputField
          type="text"
          label="Customer Name"
          placeholder="Enter Customer Name"
          value={data.deliveryAddress?.customerName || ""}
          onChange={(value) => handleChange("customerName", value)}
          error={getErrorMessage("deliveryAddress.customerName")}
          disabled={isDisabled}
        />

        <div className="flex flex-col md:flex-row gap-4">
          <InputField
            type="text"
            label="Delivery Pincode"
            placeholder="Enter Delivery Pincode"
            value={data.deliveryAddress?.pincode || ""}
            onChange={(value) => handlePincodeChange(value)}
            error={getErrorMessage("deliveryAddress.pincode")}
            disabled={isDisabled}
          />
          <InputField
            type="text"
            label="City"
            placeholder="Enter City"
            value={data.deliveryAddress?.city || ""}
            onChange={(value) => handleChange("city", value)}
            error={getErrorMessage("deliveryAddress.city")}
            disabled={isDisabled}
          />
        </div>

        <DropDownInput
          label="State"
          placeholder="Select the state"
          value={
            data.deliveryAddress?.state ||
            StatesOptions[data.deliveryAddress?.state] ||
            ""
          }
          onChange={(value) => handleChange("state", value)}
          options={statesOptionsArray}
          error={getErrorMessage("deliveryAddress.state")}
          disabled={isDisabled}
        />

        <AddressInputField
          label="Address"
          placeholder="Enter Address"
          value={data.deliveryAddress?.lines?.[0]?.line1 || ""}
          onChange={(value) => handleAddressChange("line1", value)}
          error={getErrorMessage("deliveryAddress.lines.0.line1")}
          disabled={isDisabled}
        />

        {isView && (
          <AddressInputField
            label="Address Line 2"
            placeholder="Enter Address line 2"
            value={data.deliveryAddress?.lines?.[0]?.line2 || ""}
            onChange={(value) => handleAddressChange("line2", value)}
            error={getErrorMessage("deliveryAddress.lines.0.line2")}
            disabled={isDisabled}
          />
        )}

        <InputField
          type="text"
          label="Famous Landmark (optional)"
          placeholder="Enter Landmark"
          value={data.deliveryAddress?.landmark || ""}
          onChange={(value) => handleChange("landmark", value)}
          error={getErrorMessage("deliveryAddress.landmark")}
          disabled={isDisabled}
        />

        <InputField
          type="text"
          label="Phone No. 1"
          placeholder="Enter Phone No. 1"
          value={data.deliveryPhones?.[0]?.phoneNumber || ""}
          onChange={(value) => handlePhoneChange("Primary", value)}
          error={getErrorMessage("deliveryPhones.0.phoneNumber")}
          disabled={isDisabled}
        />

        <InputField
          type="text"
          label="Phone No. 2 (optional)"
          placeholder="Enter Phone No. 2"
          value={data.deliveryPhones?.[1]?.phoneNumber || ""}
          onChange={(value) => handlePhoneChange("Secondary", value)}
          error={getErrorMessage("deliveryPhones.1.phoneNumber")}
          disabled={isDisabled}
        />

        <InputField
          type="text"
          label="GST Number"
          placeholder="Enter GST Number"
          value={data.deliveryAddress?.gstNumber || ""}
          onChange={(value) => handleChange("gstNumber", value)}
          error={getErrorMessage("deliveryAddress.gstNumber")}
          disabled={isDisabled}
        />
      </form>
    </div>
  );
};

export default DeliveryDetails;
